import React from 'react';
import { Box } from 'apps/sigma2-ui/src/components/ui/Box';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { GenericCustomVizErrorPlaceholderSvg } from 'apps/sigma2-ui/src/components/svg/GenericCustomVizErrorPlaceholder';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const GoogleMapFailure: React.FC = () => {
  const language = useLanguage();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minH="96"
      w="full"
    >
      <Box maxW="prose" h="full">
        <Spacing
          direction="vertical"
          size={'sm'}
          className="items-center justify-center py-8 px-8 bg-white h-full text-center"
        >
          <GenericCustomVizErrorPlaceholderSvg />
          <S2Typography
            variant="headline-6-alt"
            translatedContent={language.analysisGenericFailureTitle()}
          />
          <S2Typography
            variant="body-7"
            translatedContent={language.analysisGenericFailureBody()}
          />
        </Spacing>
      </Box>
    </Box>
  );
};
